import React from 'react';
import { Radio } from "antd";

const RadioButtonGroup = ({selected, setSelected, showHelperText}: any) => {

    const handleChange = (e :any) => {
        setSelected(e.target.value);
    };
  
    return (
      <div className='checkbox-wrapper'>
        {showHelperText ? <div className='map-text-helper'>
          Only one will be enabled at a time at marketing page ( Only selected section will be visible on marketing )
        </div> : ""}
        <Radio.Group onChange={handleChange} value={selected}>
          {/* <Radio value="address" className="bold-radio">Address</Radio> */}
          <Radio value="graphic" className="bold-radio">Graphic</Radio>
          <Radio value="link" className="bold-radio">Link</Radio>
        </Radio.Group>
      </div>
    );
  };

  export default RadioButtonGroup;